export default {
  imgs: [
    {
      name: "对战",
      src: require(`@img/nav/battle.png`),
    },
    {
      name: "怪兽",
      src: require(`@img/nav/mypet.png`),
    },
    {
      name: "任务",
      src: require(`@img/nav/task.png`),
    },
    // icon
    {
      name: "水晶矿",
      src: require(`@img/icon/icon-coin_53x58.png`),
    },
    {
      name: "水晶矿2",
      src: require(`@img/icon/icon-coin_42x46.png`),
    },
    {
      name: "水晶矿3",
      src: require(`@img/icon/icon-coin_88x100.png`),
    },
    {
      name: "等级背景",
      src: require(`@img/icon/icon-lv.png`),
    },
    {
      name: "新内容提示小红点",
      src: require(`@img/icon/icon-new_dot.png`),
    },
    {
      name: "改名按钮",
      src: require(`@img/icon/icon-rename.png`),
    },
    {
      name: "任务奖品1-水晶",
      src: require(`@img/icon/icon-diamond.png`),
    },
    {
      name: "任务奖品2-积分",
      src: require(`@img/icon/icon-gold.png`),
    },
    {
      name: "返回按钮",
      src: require(`@img/icon/icon-back.png`),
    },
    {
      name: "排行榜按钮",
      src: require(`@img/icon/icon-rank.png`),
    },
    {
      name: "勾号",
      src: require(`@img/icon/icon-selected.png`),
    },
    {
      name: "对战当前怪物指示",
      src: require("@img/icon/icon-battle_tig.png"),
    },
    {
      name: "宝剑",
      src: require("@img/icon/icon-sword.png"),
    },
    {
      name: "排名1",
      src: require("@img/icon/icon-rank_1.png"),
    },
    {
      name: "排名2",
      src: require("@img/icon/icon-rank_2.png"),
    },
    {
      name: "排名3",
      src: require("@img/icon/icon-rank_3.png"),
    },
    {
      name: "音效-on",
      src: require("@img/icon/icon-efsound_on.png"),
    },
    {
      name: "音效-off",
      src: require("@img/icon/icon-efsound_off.png"),
    },
    {
      name: "背景音效-on",
      src: require("@img/icon/icon-sound_on.png"),
    },
    {
      name: "背景音效-off",
      src: require("@img/icon/icon-sound_off.png"),
    },
    // v2.0
    {
      name: "手型提示",
      src: require("@img/icon/icon-new_dot_2.png"),
    },
    {
      name: "乐园赛季积分",
      src: require("@img/icon/icon-village_jf.png"),
    },
    {
      name: "乐园货币",
      src: require("@img/icon/icon-village_hb.png"),
    },
    {
      name: "乐园新手引导图标",
      src: require("@img/icon/icon-village_guidance.png"),
    },
    {
      name: "next按钮",
      src: require("@img/icon/icon-next.png"),
    },
    {
      name: "skip按钮",
      src: require("@img/icon/icon-skip.png"),
    },
    {
      name: "tip问号",
      src: require("@img/icon/icon-tip.png"),
    },
    {
      name: "列表为空图标_1",
      src: require("@img/icon/empty_1.png"),
    },
    {
      name: "列表为空图标_2",
      src: require("@img/icon/empty_2.png"),
    },
    {
      name: "增加图标",
      src: require("@img/icon/icon-addition.png"),
    },
    {
      name: "GTA积分",
      src: require("@img/icon/icon-gta_jf.png"),
    },
    // v2.0 end
  ],
};
